import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../../components/ui/Button';
import SafeIcon from '../../common/SafeIcon';
import { Card, CardContent } from '../../components/ui/Card';
import { Link } from 'react-router-dom';

export const ForHR = () => {
  return (
    <div className="py-24 space-y-32">
      <section className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-50 text-indigo-700 text-[10px] font-black uppercase tracking-widest border border-indigo-100">
              For HR & Ledelse
            </div>
            <h1 className="text-5xl md:text-6xl font-black text-slate-900 leading-none tracking-tighter uppercase">
              Strategisk oversikt over <br/> <span className="text-indigo-600">organisasjonshelsen</span>
            </h1>
            <p className="text-xl text-slate-500 leading-relaxed font-medium">
              Fra komplekse datasett til forståelige styrerapporter. HMS-innsikt gir HR-avdelingen verktøyene som trengs for å drive systematisk arbeidsmiljøarbeid i stor skala.
            </p>
            <div className="flex gap-4">
              <Link to="/booking"><Button variant="primary" size="lg">Be om Demo</Button></Link>
            </div>
          </div>
          <div className="p-8 bg-white rounded-[64px] border border-slate-100 shadow-3xl">
             <div className="grid grid-cols-2 gap-4">
               {[
                 { label: 'Heatmaps', icon: 'Map' },
                 { label: 'Compliance', icon: 'ShieldCheck' },
                 { label: 'Board Reports', icon: 'FileText' },
                 { label: 'Risk Tracking', icon: 'AlertTriangle' }
               ].map((m, i) => (
                 <div key={i} className="p-8 bg-slate-50 rounded-[40px] text-center space-y-4">
                   <SafeIcon name={m.icon} className="text-indigo-600 text-4xl mx-auto" />
                   <p className="font-black text-slate-900 uppercase tracking-widest text-[10px]">{m.label}</p>
                 </div>
               ))}
             </div>
          </div>
        </div>
      </section>

      <section className="bg-slate-900 py-32 text-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
            <div className="space-y-6">
              <h2 className="text-4xl font-black uppercase tracking-tighter">Full kontroll på Compliance</h2>
              <p className="text-xl text-slate-400 font-medium">
                Vårt system automatiserer dokumentasjonen som kreves av Arbeidstilsynet (§ 4-3). Du har alltid sanntidsoversikt over risikoområder og gjennomførte tiltak.
              </p>
              <div className="pt-8 space-y-4">
                {[
                  'Systematisk kartlegging ihht. lovverket',
                  'Digital handlingsplan med ansvarliggjøring',
                  'Automatiserte styrerapporter og sammendrag',
                  'Benchmark mot bransjenstandarder'
                ].map((item, i) => (
                  <div key={i} className="flex gap-4 items-center">
                    <SafeIcon name="CheckCircle" className="text-indigo-400" />
                    <span className="font-bold">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative">
              <div className="absolute inset-0 bg-indigo-600/20 rounded-[64px] blur-3xl"></div>
              <Card className="bg-white/5 border-white/10 text-white relative z-10 p-12 rounded-[64px]">
                <CardContent className="p-0 text-center space-y-8">
                  <SafeIcon name="Activity" className="text-7xl text-indigo-400 mx-auto" />
                  <h3 className="text-3xl font-black uppercase tracking-tight italic">"En game-changer for vår HR-rapportering"</h3>
                  <p className="text-slate-400 font-medium uppercase tracking-[0.2em] text-xs">HR Direktør, TechCorp AS</p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};